export default "__VITE_ASSET__CIFuD0Ps__"